"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var sizeMapping = {
    extraLarge: 48,
    extraSmall: 12,
    large: 32,
    medium: 24,
    small: 16,
};
var withAdjustedProps = function (WrappedComponent) {
    var SvgFilePdf = function (_a) {
        var testID = _a.testID, _b = _a.size, size = _b === void 0 ? "small" : _b, _c = _a.fill, fill = _c === void 0 ? "#000" : _c, restOfProps = __rest(_a, ["testID", "size", "fill"]);
        var sizeValue = sizeMapping[size];
        var testIdProps = {};
        return (React.createElement(WrappedComponent, __assign({ height: sizeValue, width: sizeValue, viewBox: "0 0 24 24", fill: fill, "data-testid": testID }, testIdProps, restOfProps)));
    };
    return SvgFilePdf;
};
function SvgFilePdf(_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ width: 24, height: 24, role: "img", "aria-labelledby": titleId }, props),
        title === undefined ? (React.createElement("title", { id: titleId }, "file-pdf")) : title ? (React.createElement("title", { id: titleId }, title)) : null,
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_9002_972" },
                React.createElement("rect", { id: "svg_1", width: 16, height: 16, fill: "white", transform: "translate(4.83154 4.44531)" }))),
        React.createElement("g", { className: "layer" },
            React.createElement("g", { id: "svg_2", clipPath: "url(#clip0_9002_972)", transform: "translate(-0.722503 -1.33261) scale(1 0.963722) translate(0.722503 1.33261) translate(25.4222 -1.33261) matrix(1.50656 0 0 1.59783 -32.4214 -6.11033)" },
                React.createElement("path", { id: "svg_3", d: "M11.8 18.1q-.6 0-.6-.7v-5q0-.6.6-.6c1.5 0 2.7 1.2 2.7 2.6v1c0 1.5-1.2 2.7-2.7 2.7m.7-4.8v3.3q.6-.4.7-1v-1.2q0-.7-.7-1m7.9-5.5L17.5 5l-1.1-.5H7q-1 0-1.6.6t-.6 1.6v11.7q0 .9.6 1.5t1.6.6h11.7q2-.2 2.1-2V8.8q0-.6-.4-1.1m-1.2.6h-2q-.4 0-.4-.3V6zm.3 10q0 .6-.8.7H7l-.6-.2q-.3-.3-.2-.6V6.6l.2-.6q.2-.3.6-.2h8.5V8q.1 1.6 1.7 1.7h2.3zM16.8 13h1q.6 0 .7-.7 0-.5-.7-.6h-1q-1.5.1-1.6 1.6v4q0 .6.6.7t.7-.7V16h.8q.6 0 .7-.7-.1-.5-.7-.6h-.8v-1.4q0-.3.3-.3m-8.5-1.3h-.5q-.5 0-.6.6v5q0 .6.6.7t.7-.7V16c1.1 0 2-1 2-2.1s-1-2.2-2.2-2.2m.2 3V13q.7.1.7.8t-.7.9" })))));
}
exports.default = withAdjustedProps(SvgFilePdf);
